import { useState } from 'react'
import { Link, useLocation } from 'react-router-dom'
import MobileNav from './MobileNav'

const navLinks = [
  { label: 'Overview', href: '/overview' },
  { label: 'Features', href: '/features' },
  { label: 'Demo', href: '/demo' },
  { label: 'About', href: '/about' },
  { label: 'Pricing', href: '/pricing' },
]

export default function Header() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false)
  const location = useLocation()

  const toggleMobileMenu = () => {
    setMobileMenuOpen(!mobileMenuOpen)
  }

  const closeMobileMenu = () => {
    setMobileMenuOpen(false)
  }

  return (
    <>
      <nav className="sticky top-0 z-[100] w-full bg-brand-dark/80 backdrop-blur-[20px] border-b border-white/[0.06] px-6">
        <div className="max-w-[1200px] mx-auto flex items-center justify-between h-20">
          {/* Logo */}
          <Link to="/" className="flex items-center gap-3 no-underline" onClick={closeMobileMenu}>
            <svg className="w-8 h-8" viewBox="0 0 64 64" fill="none">
              <defs>
                <linearGradient id="headerEggLight" x1="0%" y1="0%" x2="0%" y2="100%">
                  <stop offset="0%" stopColor="#5eead4" />
                  <stop offset="100%" stopColor="#14b8a6" />
                </linearGradient>
                <linearGradient id="headerEggMid" x1="0%" y1="0%" x2="100%" y2="100%">
                  <stop offset="0%" stopColor="#14b8a6" />
                  <stop offset="100%" stopColor="#0d9488" />
                </linearGradient>
                <linearGradient id="headerEggDark" x1="0%" y1="0%" x2="0%" y2="100%">
                  <stop offset="0%" stopColor="#0d9488" />
                  <stop offset="100%" stopColor="#0f766e" />
                </linearGradient>
              </defs>
              {/* Main egg/droplet shape */}
              <path
                d="M32 4 C18 4 8 20 8 36 C8 52 18 60 32 60 C46 60 56 52 56 36 C56 20 46 4 32 4Z"
                fill="url(#headerEggLight)"
              />
              {/* Wave layers */}
              <path
                d="M12 38 Q22 32 32 38 Q42 44 52 38 L52 48 Q42 54 32 48 Q22 54 12 48 Z"
                fill="url(#headerEggMid)"
                opacity="0.9"
              />
              <path
                d="M14 46 Q24 40 32 46 Q40 52 50 46 L50 54 Q40 60 32 54 Q24 60 14 54 Z"
                fill="url(#headerEggDark)"
                opacity="0.85"
              />
              {/* Gold accent curves */}
              <path
                d="M20 24 Q26 20 32 24"
                stroke="#B8956A"
                strokeWidth="2"
                strokeLinecap="round"
                fill="none"
                opacity="0.7"
              />
              <path
                d="M36 20 Q40 18 44 20"
                stroke="#B8956A"
                strokeWidth="1.5"
                strokeLinecap="round"
                fill="none"
                opacity="0.5"
              />
            </svg>
            <div className="font-serif text-[22px] font-medium tracking-[-0.02em] text-brand-light">
              Wealth<span className="text-accent-tealLight">Space</span>
            </div>
          </Link>

          {/* Desktop Navigation */}
          <div className="hidden min-[900px]:flex gap-10">
            {navLinks.map((link) => (
              <Link
                key={link.href}
                to={link.href}
                className={`relative text-[15px] font-medium transition-colors duration-300 no-underline
                  ${location.pathname === link.href ? 'text-brand-light' : 'text-brand-muted hover:text-brand-light'}
                  after:content-[''] after:absolute after:bottom-[-4px] after:left-0 after:h-[2px] after:bg-accent-teal
                  after:transition-[width] after:duration-300
                  ${location.pathname === link.href ? 'after:w-full' : 'after:w-0 hover:after:w-full'}
                `}
              >
                {link.label}
              </Link>
            ))}
          </div>

          {/* CTA Button - Desktop */}
          <Link
            to="/get-started"
            className="hidden min-[900px]:inline-flex items-center gap-2 bg-gradient-to-br from-accent-teal to-emerald-500 text-brand-darkAlt px-6 py-3 rounded-md font-semibold text-sm transition-all duration-300 shadow-button hover:-translate-y-0.5 hover:shadow-button-hover no-underline"
          >
            Get Started
          </Link>

          {/* Hamburger Button - Mobile */}
          <button
            className="min-[900px]:hidden flex flex-col justify-center items-center w-11 h-11 bg-white/5 border border-white/10 rounded-lg cursor-pointer gap-[5px]"
            onClick={toggleMobileMenu}
            aria-label={mobileMenuOpen ? 'Close menu' : 'Open menu'}
            aria-expanded={mobileMenuOpen}
          >
            <span
              className={`block w-5 h-[2px] bg-brand-light rounded-sm transition-all duration-300
                ${mobileMenuOpen ? 'rotate-45 translate-x-[5px] translate-y-[5px]' : ''}
              `}
            />
            <span
              className={`block w-5 h-[2px] bg-brand-light rounded-sm transition-opacity duration-300
                ${mobileMenuOpen ? 'opacity-0' : ''}
              `}
            />
            <span
              className={`block w-5 h-[2px] bg-brand-light rounded-sm transition-all duration-300
                ${mobileMenuOpen ? '-rotate-45 translate-x-[5px] -translate-y-[5px]' : ''}
              `}
            />
          </button>
        </div>
      </nav>

      {/* Mobile Menu */}
      <MobileNav isOpen={mobileMenuOpen} onClose={closeMobileMenu} links={navLinks} />
    </>
  )
}
